exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dataTable[data-v-52e2a94a] .categories p,.dataTable[data-v-52e2a94a] .categories span{font-size:14px;line-height:1.25}", ""]);

// exports
